import Vue from 'vue'
const isServer = Vue.prototype.$isServer

/* istanbul ignore next */
export const on = (function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        // console.log("addEventListener:", handler);
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (event, handler) {
      if (element && event && handler) {
        // console.log("attachEvent:", handler);
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/* istanbul ignore next */
export const off = (function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        // console.log("removeEventListener:", handler);
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        // console.log("removeEventListener:", handler);
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()
